import MarkdownIt from 'markdown-it';
import React from 'react';
const md = new MarkdownIt();

const Markdown = ({ text }: { text: string }) => <div dangerouslySetInnerHTML={{ __html: md.render(text) }} />;

export default Markdown;
